import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Skeleton,
  useDisclosure,
} from '@chakra-ui/react';
import 'reactflow/dist/style.css';
import { useColorValue, useFormState } from '~/hooks';
import { Chart } from './chart';
import { PathButton } from './path-button';

interface PathProps {
  device: string;
}

export const Path = (props: PathProps): JSX.Element => {
  const { device } = props;
  const displayTarget = useFormState(s => s.target.display);
  const getResponse = useFormState(s => s.response);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const response = getResponse(device);
  const output = response?.output as StructuredResponse;
  const bg = useColorValue('light.50', 'dark.900');
  return (
    <>
      <PathButton onOpen={onOpen} />
      <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered>
        <ModalOverlay />
        <ModalContent
          bg={bg}
          m={2}
          minH={0}
          w="calc(100% - 1rem)"
          maxW="calc(100% - 1rem)"
          h="calc(100dvh - 1rem)"
          maxH="calc(100dvh - 1rem)"
          overflow="hidden"
        >
          <ModalHeader flexShrink={0} pr={12} overflowWrap="anywhere">{`Path to ${displayTarget}`}</ModalHeader>
          <ModalCloseButton />
          <ModalBody p={{ base: 2, md: 4 }} pt={0} flex="1" minH={0} minW={0}>
            {response !== null ? <Chart data={output} /> : <Skeleton w="100%" h="100%" />}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
